import React from 'react';
import LinksTable from "../components/LinksTable";
import wx from "../data/wx";

function WebLinksPage() {
    
    return (
        <>
        <article className="App-weather">
        
        <LinksTable websx={wx}/> 
        </article>

    </>
    );
}
export default WebLinksPage;
